import { AlertTriangle, CircleAlert } from 'lucide-react';
import '../advance-notices.css';

export interface IssueItem {
  message: string;
  rowIndex?: number | null;
}

/**
 * 保存時チェックのエラー・警告の一覧（kintone のアラートに相当）。G2 の各画面で共用。
 * rowLabel を渡すと「n行目」等の行番号を前置する。
 */
export function IssueList({
  tone,
  title,
  items,
  rowLabel,
}: {
  tone: 'error' | 'warning';
  title: string;
  items: IssueItem[];
  rowLabel?: (rowIndex: number) => string;
}) {
  if (!items.length) return null;
  const Icon = tone === 'error' ? CircleAlert : AlertTriangle;
  return (
    <div className={`bs-g2-issues bs-g2-issues--${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <div className="bs-g2-issues__title">
        <Icon size={16} aria-hidden />
        {title}
        <span className="bs-g2-issues__count">{items.length}件</span>
      </div>
      <ul>
        {items.map((i, k) => (
          <li key={k}>
            {rowLabel && i.rowIndex != null && <span className="bs-g2-issues__row">{rowLabel(i.rowIndex)}</span>}
            {i.message}
          </li>
        ))}
      </ul>
    </div>
  );
}
